import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import icons from "../../../assets/images/constantIcons";
import toast from "react-hot-toast";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import apiService, { handleError } from "../../Common/ApiCommon/ApiService";

const ApplyLeaveForm = ({ staffId }) => {

  const formik = useFormik({
    initialValues: {
      staff_user_id: "",
      leave_type: "",
      from_date: "",
      to_date: "",
      from_date_session: "session_1",
      to_date_session: "session_2",
      contact_detail: "",
      reason: "",
    },
    validationSchema: Yup.object({
      leave_type: Yup.string().required("Leave type is required"),
      from_date: Yup.date().required("From date is required"),
      to_date: Yup.date()
        .required("To date is required")
        .min(Yup.ref("from_date"), "To date must be after From date"),
      from_date_session: Yup.string().required("Session selection is required"),
      to_date_session: Yup.string().required("Session selection is required"),
      reason: Yup.string().required("Reason is required"),
    }),
    onSubmit: async (values) => {
      try {
        const leavePayload = {
          leave: {
            leave_type: values.leave_type,
            from_date_session: values.from_date_session,
            to_date_session: values.to_date_session,
            from_date: values.from_date,
            to_date: values.to_date,
            contact_detail: values.contact_detail,
            reason: values.reason,
            staff_user_id: Number(staffId),
          }
        };

        const response = await apiService.post("/leaves", leavePayload);
        toast.success(response.message, { duration: 2000 });
        formik.resetForm();
      } catch (errors) {
        handleError(errors);
      }


    },
  });

  return (
    <div className="flex flex-col items-start bg-white rounded-2xl px-0 sm:p-4 ">
      <h1 className="main_heading text-2xl mb-5 pl-4 mt-3 sm:pl-0">  Apply Leave</h1>

      {/* Form */}
      <form onSubmit={formik.handleSubmit} className="space-y-4 text-start w-full md:w-10/12 px-2 sm:px-0">
        {/* Leave Type */}
        <div className="text-G300 w-full xs:w-1/2 ">
          <label className="block text-sm font-normal mb-2">Leave type</label>
          <select
            name="leave_type"
            className="inputtext placeholder:text-G50"
            value={formik.values.leave_type}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          >
            <option value="">Select type</option>
            <option value="casual">Casual leave</option>
            <option value="sick">Sick leave</option>
          </select>
          {formik.touched.leave_type && formik.errors.leave_type && (
            <div className="text-red text-sm">{formik.errors.leave_type}</div>
          )}
        </div>

        {/* From Date */}
        <div className="text-G300 flex flex-col xs:flex-row w-full ">
          <div className="w-full xs:w-1/2">
            <label className="block text-sm font-normal mb-2">From date</label>
            <div className="relative">
              <DatePicker
                selected={
                  formik.values.from_date
                    ? new Date(formik.values.from_date)
                    : null
                }
                onChange={(from_date) =>
                  formik.setFieldValue(
                    "from_date",
                    from_date.toString()
                  )
                }
                placeholderText="yyyy-mm-dd"
                dateFormat="yyyy-MM-dd"
                className="inputtext placeholder:text-G50 w-full pr-10"
              />
              <icons.MdOutlineCalendarMonth className="absolute right-3 top-3 text-green pointer-events-none" />
            </div>

            {formik.touched.from_date && formik.errors.from_date && (
              <div className="text-red text-sm">{formik.errors.from_date}</div>
            )}
          </div>
          {/* Session */}
          <div className="text-G300 w-full xs:w-1/2 pl-0 xs:pl-5 mt-4 xs:mt-0">
            <label className="block text-sm font-normal mb-2">Session</label>
            <select
              name="from_date_session"
              className="inputtext placeholder:text-G50"
              value={formik.values.from_date_session}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">Select Session</option>
              <option value="session_1">Session 1</option>
              <option value="session_2">Session 2</option>
            </select>
            {formik.touched.from_date_session && formik.errors.from_date_session && (
              <div className="text-red text-sm">{formik.errors.from_date_session}</div>
            )}
          </div>
        </div>

        {/* To Date */}
        <div className="text-G300 flex flex-col xs:flex-row w-full">
          <div className="w-full xs:w-1/2">
            <label className="block text-sm font-normal mb-2">To date</label>
            <div className="relative">
              <DatePicker
                selected={
                  formik.values.to_date
                    ? new Date(formik.values.to_date)
                    : null
                }
                onChange={(to_date) =>
                  formik.setFieldValue(
                    "to_date",
                    to_date.toString()
                  )
                }
                placeholderText="yyyy-mm-dd"
                dateFormat="yyyy-MM-dd"
                className="inputtext placeholder:text-G50 w-full pr-10"
              />
              <icons.MdOutlineCalendarMonth className="absolute right-3 top-3 text-green pointer-events-none" />
            </div>
            {formik.touched.to_date && formik.errors.to_date && (
              <div className="text-red text-sm">{formik.errors.to_date}</div>
            )}
          </div>
          {/* Session */}
          <div className="text-G300  w-full xs:w-1/2 pl-0 xs:pl-5 mt-4 xs:mt-0">
            <label className="block text-sm font-normal mb-2">Session</label>
            <select
              name="to_date_session"
              className="inputtext placeholder:text-G50"
              value={formik.values.to_date_session}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">Select Session</option>
              <option value="session_1">Session 1</option>
              <option value="session_2">Session 2</option>
            </select>
            {formik.touched.to_date_session && formik.errors.to_date_session && (
              <div className="text-red text-sm">{formik.errors.to_date_session}</div>
            )}
          </div>
        </div>

        {/* Contact Detail */}
        <div className="text-G300 w-full xs:w-1/2">
          <label className="block text-sm font-normal mb-2">
            Contact detail
          </label>
          <input
            type="text"
            name="contact_detail"
            placeholder="89087 98767"
            className="inputtext placeholder:text-G50"
            value={formik.values.contact_detail}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />

        </div>

        {/* Reason */}
        <div className="text-G300 ">
          <label className="block text-sm font-normal mb-2">Reason</label>
          <textarea
            name="reason"
            rows={3}
            className="inputtext placeholder:text-G50"
            value={formik.values.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {formik.touched.reason && formik.errors.reason && (
            <div className="text-red text-sm">{formik.errors.reason}</div>
          )}
        </div>


        {/* Buttons */}
        <div className="flex justify-start space-x-7 mt-4">
        <button
            type="submit"
            className="px-4 py-2 w-full bg-green text-white rounded-lg cardtext"
          >
            Submit
          </button>
          <button
            type="button"
            onClick={() => formik.resetForm()}
            className="px-4 py-2 w-full bg-white text-green rounded-lg border border-green cardtext"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default ApplyLeaveForm;
